<div
  class="main-footer"
  [class.event-footer]="isEventFooter"
  [class.premium-footer]="event?.isPremium()"
  [class.generic]="isGenericFooter"
  [class.book-a-slot-footer]="isBookASlotFooter"
  [class.public-footer]="isPublicFooter"
  [style.color]="bodyColor ? bodyColor : ''"
  [style.backgroundColor]="backgroundColor ? backgroundColor : ''"
  [class.is-logged]="loggedUser !== undefined && loggedUser.id > 0"
>
  @if (showLogo && isGenericFooter) {
    <div
      class="footer-powered-by-cont weddingpage generic-page"
      [ngStyle]="
        !isBookASlotFooter
          ? {
              'border-top': '1px solid ' + bodyColor
            }
          : {}
      "
    >
      <span>{{ "APP.POWERED_BY" | translate }}</span>
      <app-logo-custom-fill
        class="custom-logo-fill"
        [fillColor]="bodyColor || 'none'"
        [isGenericPage]="isGenericFooter"
        [height]="22"
      />
    </div>
  }
  @if (!isGenericFooter && showLogo) {
    @if (env.platform === "weddingpage.ai") {
      <div class="footer-powered-by-cont weddingpage">
        <span>{{ "APP.POWERED_BY" | translate }}</span>
        <app-logo-custom-fill
          [fillColor]="bodyColor || 'var(--brand-primary)'"
          [height]="22"
          [isWeddingPage]="true"
        />
      </div>
    } @else {
      <div class="footer-info">
        @if (!useCustom) {
          <a class="footer-brand" routerLink="/">
            <img
              class="media-object footer-logo custom"
              [src]="getFooterLogo()"
              alt="eventpage.ai - Logo"
            />
          </a>
        } @else {
          <div class="footer-brand">
            <img
              class="media-object footer-logo custom"
              [src]="getFooterLogo()"
              alt="eventpage.ai - Logo"
            />
          </div>
        }
        <div class="personal-info">
          <div class="legal-info">
            @if (!useCustom) {
              <div class="item">
                Copyright © {{ currentYear }} eventpage.ai GmbH.<br />All
                rights received.
              </div>
            } @else {
              @if (
                event && event.eventTemplate && event.eventTemplate.legalInfo
              ) {
                @if (event.eventTemplate.legalInfo.companyName) {
                  <div class="item" [ngStyle]="getItemStyle()">
                    {{ getContactName() }}
                  </div>
                }
                @if (getCompanyAddress()) {
                  <div class="item" [ngStyle]="getItemStyle()">
                    {{ getCompanyAddress() }}
                  </div>
                }
                @if (getContactInfo()) {
                  <div class="item" [ngStyle]="getItemStyle()">
                    {{ getContactInfo() }}
                  </div>
                }
              }
            }
          </div>
          @if (haveSocialMediaLinks()) {
            <div class="social-media-buttons-wrapper">
              @if (isOver600 !== undefined) {
                <app-edit-social-media-buttons
                  [isEditMode]="false"
                  [asSvg]="true"
                  [event]="event"
                  [biggerSize]="!isOver600"
                  [alignEnd]="isOver600"
                  [socialMedia]="event?.eventTemplate?.socialMedia"
                  class="social-media-buttons"
                />
              }
            </div>
          }
        </div>
      </div>
    }
  }
  @if (!isGenericFooter && isPublicFooter && !isDesktop) {
    <div class="mobile-logo">
      @if (includePoweredBy) {
        <div class="powered-by-mobile">
          <span>{{ "APP.POWERED_BY" | translate }}</span>
          <a class="footer-brand" routerLink="/">
            <img
              class="media-object footer-logo"
              [src]="userTheme === 'dark' ? env.logoDarkAsset : env.logoAsset"
              alt="eventpage.ai - Logo"
            />
          </a>
        </div>
      } @else {
        <a class="footer-brand" routerLink="/">
          <img
            class="media-object footer-logo"
            [src]="userTheme === 'dark' ? env.logoDarkAsset : env.logoAsset"
            alt="eventpage.ai - Logo"
          />
        </a>
      }

      <div class="language-switcher">
        <button [matMenuTriggerFor]="appMenu" class="menu-button">
          <i class="fal fa-globe"></i>
          <span>{{ selectedLanguage | translate }}</span>
          <i class="far fa-chevron-down"></i>
        </button>
      </div>
    </div>
  }

  @if (showOptions) {
    <ul class="widget-list">
      @if (useCustom) {
        @if (
          event &&
          event.eventTemplate &&
          event.eventTemplate.legalInfo &&
          event.eventTemplate.legalInfo.links.length > 0
        ) {
          @for (link of event.eventTemplate.legalInfo.links; track $index) {
            @if (link.isValid()) {
              <li
                class="widget-item"
                [ngStyle]="{
                  borderColor:
                    bodyColor || event.eventTemplate.visual?.footerBodyColor
                }"
              >
                <a
                  [href]="link.link"
                  target="_blank"
                  [ngStyle]="{
                    color: event.eventTemplate.visual?.footerBodyColor
                  }"
                  >{{
                    link.customLabel || getLegalInfoDisplayName(link.type)
                      | translate
                  }}
                </a>
              </li>
            }
          }
        }
      } @else {
        <li class="widget-item">
          <a href="https://eventpage.ai/imprint" target="_blank">{{
            "APP.IMPRINT" | translate
          }}</a>
        </li>

        <li class="widget-item">
          <a
            href="https://eventpage.ai/datenschutzerklaerung/"
            target="_blank"
            >{{ "APP.DATA_PRIVACY" | translate }}</a
          >
        </li>

        <li class="widget-item">
          <a href="https://eventpage.ai/terms-of-use/" target="_blank">{{
            "APP.TERMS_AND_CONDITIONS_SHORT" | translate
          }}</a>
        </li>

        <li class="widget-item">
          <a href="mailto:support@eventpage.ai" class="text-link">{{
            "APP.HELP" | translate
          }}</a>
        </li>
      }

      @if (isDesktop && !isEventFooter) {
        <li class="widget-item">
          <button [matMenuTriggerFor]="appMenu" class="menu-button">
            <i class="fal fa-globe"></i>
            <span>{{ selectedLanguage | translate }}</span>
            <i class="far fa-chevron-down"></i>
          </button>
        </li>
      }
    </ul>

    @if (event?.useCustomFooter && event?.isPremium()) {
      @if (
        event &&
        event.eventTemplate &&
        event.eventTemplate.legalInfo &&
        event.eventTemplate.legalInfo.isWebsiteValid()
      ) {
        <a
          href="{{ event.eventTemplate.legalInfo.getWebsiteUrl() }}"
          target="_blank"
          class="footer-website"
          >{{ event.eventTemplate.legalInfo.website }}</a
        >
      }
    }

    @if ((event?.useCustomFooter || event?.isGeneric()) && showPoweredBy) {
      <div class="row">
        <div class="footer-powered-by-cont">
          <span>{{ "APP.POWERED_BY" | translate | lowercase }}</span>
          <app-logo-custom-fill
            [fillColor]="
              event?.eventTemplate?.visual?.footerBodyColor || 'white'
            "
            [isGenericPage]="true"
            [height]="16"
            [isSmallLogo]="false"
            class="custom-logo"
          />
        </div>
      </div>
    }
  }

  <mat-menu #appMenu="matMenu" class="mat-menu-actions-container mb-1">
    @for (item of languageData; track $index) {
      <button mat-menu-item (click)="onMenuEvent(item.label)">
        {{ item.label | translate }}
      </button>
    }
  </mat-menu>
</div>
